import type { ContactUsDictionary } from '@/shared/types';
import { useDictionary, type UseDictionaryOptions } from '.';

type ContactUsDictionaryOptions = Omit<
  UseDictionaryOptions<ContactUsDictionary>,
  'dictionaryName'
>;

const useContactUsDictionary = (options: ContactUsDictionaryOptions = {}) => {
  const { data, isLoading, error } = useDictionary<ContactUsDictionary>({
    dictionaryName: 'contactus',
    ...options,
  });

  return {
    contactUsDictionaryData: data,
    isContactUsDictionaryLoading: isLoading,
    isContactUsDictionaryError: error,
  };
};

export { useContactUsDictionary };
